import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'summaryTaxDiscountFormat'
})

export class SummaryTaxDiscountFormatPipe implements PipeTransform {
  transform(data, currency, type) {
    return (type === 'discount' && data.type === 'Fixed' ? '-' : '') + data.value + (data.type === '%' ? '%' : ' '+currency);
  }
}
